import { Controller } from "react-hook-form";
import {
  Radio,
  Input,
  Form,
  InputNumber,
  Upload,
  Progress,

  Switch,
  Button,
} from "antd";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebaseConfig";
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons";
import { useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { UploadOutlined } from "@ant-design/icons";
import toast from 'react-hot-toast';
import axios from "axios";
const { TextArea } = Input;
const { Dragger } = Upload;
export const RadioGroupFI = ({
  children,
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Form.Item
          label={<b>{label}</b>}
          validateStatus={!!error ? "error" : "validating"}
          help={
            error && error.type === "required" ? `${label} is required!` : ""
          }
          //   hasFeedback={!!error}
          required={required}
        >
          <Radio.Group {...props} {...field}>
            {children}
          </Radio.Group>
        </Form.Item>
      )}
    />
  );
};

export const SwitchFI = ({
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Form.Item
            label={<b>{label}</b>}
            validateStatus={!!error ? "error" : "validating"}
            help={
              error && error.type === "required" ? `${label} is required!` : ""
            }
            // hasFeedback={!!error}
            required={required}
          >
            <Switch
              {...props}
              checked={field.value}
              onChange={field.onChange}
            />
          </Form.Item>
        );
      }}
    />
  );
};

export const TextInputFI = ({
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Form.Item
            label={<b>{label}</b>}
            validateStatus={!!error ? "error" : "validating"}
            help={
              error && error.type === "required" ? `${label} is required!` : ""
            }
            // hasFeedback={!!error}
            required={required}
          >
            <Input {...props} {...field} />
          </Form.Item>
        );
      }}
    />
  );
};

export const NumberInputFI = ({
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Form.Item
            label={<b>{label}</b>}
            validateStatus={!!error ? "error" : "validating"}
            help={
              error && error.type === "required" ? `${label} is required!` : ""
            }
            // hasFeedback={!!error}
            required={required}
          >
            <InputNumber {...props} {...field} />
          </Form.Item>
        );
      }}
    />
  );
};

export const TextAreaInputFI = ({
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Form.Item
            label={<b>{label}</b>}
            validateStatus={!!error ? "error" : "validating"}
            help={
              error && error.type === "required" ? `${label} is required!` : ""
            }
            // hasFeedback={!!error}
            required={required}
          >
            <TextArea {...props} {...field} />
          </Form.Item>
        );
      }}
    />
  );
};

export const FileUploadFI = ({
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [progressValue, setProgressValue] = useState(0);

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      toast.error("File must smaller than 10MB!");
    }
    return isLt2M;
  };

  const onFileUpload = ({ file }, form) => {
    const metadata = {
      contentType: "*",
    };
    const storageRef = ref(storage, "documents/" + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);
    setIsUploading(true);
    setProgressValue(0);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgressValue(progress.toFixed());
      },
      (error) => {
        setIsUploading(false);
        toast.error(error.code);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setIsUploading(false);
          form.onChange(downloadURL);
        });
      }
    );
  };
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Form.Item
            label={<b>{label}</b>}
            validateStatus={!!error ? "error" : "validating"}
            help={
              error && error.type === "required" ? `${label} is required!` : ""
            }
            hasFeedback={!!error}
            required={required}
          >
            {isUploading && (
              <Progress style={{ widd: "100%" }} percent={progressValue} />
            )}

            {field?.value && !isUploading && (
              <a href={field?.value} target="_blank">
                [Click here to dowload {label} file]
              </a>
            )}
            {field?.value && !isUploading && (
              <Button
                style={{ marginLeft: 16 }}
                onClick={() => field.onChange("")}
                icon={<DeleteOutlined />}
              >
                Remove
              </Button>
            )}
            {!field?.value && !isUploading && (
              <Upload
                {...props}
                name={name}
                multiple={false}
                showUploadList={false}
                beforeUpload={beforeUpload}
                customRequest={(e) => onFileUpload(e, field)}
              >
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            )}
          </Form.Item>
        );
      }}
    />
  );
};

export const DraggerFI = ({
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [progressValue, setProgressValue] = useState(0);

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      toast.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      toast.error("Image must smaller than 10MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const onFileUpload = async ({ file }, form) => {
    setIsUploading(true);
    setProgressValue(0);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "tramy_ngothuy");
    try {
      const res = await axios(
        "https://api.cloudinary.com/v1_1/dgjbkmyeq/image/upload",
        {
          method: "POST",
          data: formData,
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setProgressValue(percent);
            }
          },
        }
      );
      const { data } = res;
      if (data.secure_url) {
        form.onChange({
          url: data.secure_url,
          publicId: data.public_id,
          width: data.width,
          height: data.height,
        });
      }
    } catch (rs) {
      toast.error(rs?.response?.data?.error?.message);
    }
    setIsUploading(false);
    setProgressValue(0);
  };
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Form.Item
            label={<b>{label}</b>}
            validateStatus={!!error ? "error" : "validating"}
            help={
              error && error.type === "required" ? `${label} is required!` : ""
            }
            hasFeedback={!!error}
            required={required}
          >
            <Dragger
              {...props}
              className="custom-dragger"
              name={name}
              multiple={false}
              showUploadList={false}
              beforeUpload={beforeUpload}
              customRequest={(e) => onFileUpload(e, field)}
            >
              {!field?.value && !isUploading && (
                <div>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                </div>
              )}
              {field?.value && !isUploading && (
                <img
                  src={field?.value?.url}
                  alt="preview"
                  style={{
                    width: "100%",
                  }}
                />
              )}
              {isUploading && (
                <Progress type="circle" percent={progressValue} />
              )}
            </Dragger>
          </Form.Item>
        );
      }}
    />
  );
};

export const RichTextBoxFI = ({
  name,
  control,
  label,
  rules,
  required,
  ...props
}) => {
  let editorInstance = null;
  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Form.Item
            label={<b>{label}</b>}
            validateStatus={!!error ? "error" : "validating"}
            help={
              error && error.type === "required" ? `${label} is required!` : ""
            }
            // hasFeedback={!!error}
            required={required}
          >
            <SunEditor
              setOptions={{
                buttonList: [
                  ["undo", "redo"],
                  ["fontSize"],
                  [
                    "bold",
                    "underline",
                    "italic",
                    "strike",
                    "subscript",
                    "superscript",
                  ],
                  ["fontColor", "hiliteColor"],
                  ["align", "list", "lineHeight"],
                  ["outdent", "indent"],
                  ["table", "horizontalRule", "link", "image", "video"],
                  ["codeView"], // Thêm nút code editor
                  ["preview", "print"],
                  ["removeFormat"],
                ],
                defaultTag: "div",
                minHeight: "400px", // Tăng chiều cao
                showPathLabel: false,
                pasteAsPlainText: true, // thêm lớp bảo vệ

              }}
              {...props}
              onChange={field.onChange}
              getSunEditorInstance={(se) => {
                editorInstance = se;
              }}
              onPaste={(e) => {
                e.preventDefault();
                const text =
                  e.clipboardData?.getData("text/plain")
                if (!text || !editorInstance) return;

                editorInstance.insertHTML(text); // ✅ ĐÚNG
              }}
              name={name}
              defaultValue={field.value}
              // Thêm style font monospace khi ở chế độ code
              style={{ fontFamily: 'monospace', fontSize: 16 }}
            />
          </Form.Item>
        );
      }}
    />
  );
};
